module.exports = __webpack_public_path__ + "img/brands-and-logotypes.9a3b163e.svg";